module.exports = __webpack_public_path__ + "static/img/bg74.ff40cff4.png";